import { combineReducers } from 'redux';
import { createDataReducer } from '../../store/dataReducer';
import { createRequestReducer } from '../../store/requestReducer';
import * as actions from './commentActions';

export const initialState = {
  value: "All", 
  label: "All",
}

export function dropdownSelectedValueReducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.SET_DROPDOWN_SELECTION:
        return {
            value: action.value,
            label: action.label
        }
    default:
      return state;
  }
}

export function resolutionSummaryReducer(state = [], action = {}) {
  switch (action.type) {
    case actions.SET_RESOLUTION_SUMMARY:
      return action.data;
    default:
      return state;
  }
}

export function  commentCountByResolutionSummaryReducer(state = 0, action = {}) {
  switch (action.type) {
    case actions.SET_COUNT_RESOLUTION_SUMMARY_FOR_PROJECT: 
    return action.count;
    default:
      return state;
  }
}

export function exportExcelLoadingReducer(state = false, action = {}) {
  switch (action.type) {
    case actions.EXPORT_COMMENTS_TO_EXCEL:
      return true;
    case actions.EXPORT_COMMENTS_TO_EXCEL_SUCCESS:
    case actions.EXPORT_COMMENTS_TO_EXCEL_FAILURE:
      return false;
    default:
      return state;
  }
}

export function exportExcelErrorReducer(state = null, action = {}) {
  switch (action.type) {
    case actions.EXPORT_COMMENTS_TO_EXCEL:
    case actions.EXPORT_COMMENTS_TO_EXCEL_SUCCESS:
      return null;
    case actions.EXPORT_COMMENTS_TO_EXCEL_FAILURE:
      return action.error || 'An error occurred while exporting comments';
    default:
      return state;
  }
}

export default combineReducers({
  data: createDataReducer({
    SET_DATA: actions.SET_DATA,
    RESET_DATA: actions.RESET_DATA,
    INSERT_ITEM: actions.INSERT_ITEM,
    DELETE_ITEM: actions.DELETE_ITEM,
    UPSERT_ITEM: actions.UPDATE_ITEM,
    APPEND_DATA: actions.APPEND_DATA,
  }),
  request: createRequestReducer({
    ERROR: actions.ERROR,
    LOADING: actions.LOADING,
  }),
  commentDropdownValue: dropdownSelectedValueReducer,
  fetchAllResolutionSummary: resolutionSummaryReducer,
  fetchCommentCountByResolutionSummary: commentCountByResolutionSummaryReducer,
  exportExcelLoading: exportExcelLoadingReducer,
  exportExcelError: exportExcelErrorReducer,
});
